export default {
    new: 'Neuf',
    used: 'Occasion',
    certified: '@:lexicon.certified',
    demo: 'Démonstration',
};
